import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import map from 'lodash/map';
import size from 'lodash/size';

// import { Link } from 'react-router-dom';
import {
  Button,
  ListGroup,
  ListGroupItem
} from 'reactstrap';

// import ProjectDomainsForm from './domainsForm';

import { addDomainSuccess, deleteDomainSuccess, updateDomainSuccess } from '../../actions';
import { Domain } from '../../api'

import {FontAwesomeIcon as FA} from '@fortawesome/react-fontawesome';
import faTrashAlt from '@fortawesome/fontawesome-pro-light/faTrashAlt';
import faLock from '@fortawesome/fontawesome-pro-solid/faLock';
import faCircle from '@fortawesome/fontawesome-pro-solid/faCircle';



const mapStateToProps = state => ({});

const matchDispatchToProps = dispatch => {
  return bindActionCreators({ addDomainSuccess, deleteDomainSuccess, updateDomainSuccess }, dispatch)
};




const TurnOnSSL = ({ confirmation_status, toggleSSL, certificate_status, with_ssl }) => 
  ( with_ssl === true ?
      certificate_status === 'success' ? null : <span className="small gray">SSL {certificate_status}</span>
    : <Button
        outline
        target="_blank"
        size="sm"
        onClick={toggleSSL}
      >
        add SSL {with_ssl}
      </Button>
  )


const DomainSetupButton = ({confirmation_status, certificate_status, with_ssl, toggleSSL}) => 
  ( confirmation_status === "success" ?
      <TurnOnSSL {...{confirmation_status, certificate_status, with_ssl, toggleSSL}} />
    : <Button
      outline
      target="_blank"
      size="sm"
      href="https://intercom.help/shor/en/articles/3292662-custom-domains-shor"
    >
      Setup
    </Button>
  )


class ProjectDomainComponent extends Component {
  
  constructor(props) {
    super(props);
    this.deleteDomain = this.deleteDomain.bind(this)

    this.toggleSSL = this.toggleSSL.bind(this);
    
    this.state = {
      isDeleting: false,
    }
  }
  
  async deleteDomain(e) {
    if (e && e.preventDefault)
      e.preventDefault();
    const { domain, deleteDomainSuccess } = this.props;
    
    if (!window.confirm(`Are you sure you want to remove domain ${domain.name} from project? Links will be affected!`)){
      return;
    }
    
    const stopLoading = () => this.setState({isDeleting:false});
    
    this.setState({isDeleting:true});
    try {
      const res = await Domain.destroy({id: domain.id});
      stopLoading();
      deleteDomainSuccess(res);
    }
    catch (error) {
      stopLoading();
    }
  }
  
  async toggleSSL (e) {
    if (e)
      e.preventDefault();
    const { domain, updateDomainSuccess } = this.props;
    
    try {
      const res = await Domain.enableSSL({id: domain.id});
      updateDomainSuccess(res);
    }
    catch (error) {}
  }
  
  render() {
    const { domain, domain: {confirmation_status, certificate_status} } = this.props;
    const statusColor = confirmation_status === 'success' ? 'success' : (confirmation_status === 'failed' ? 'danger' : 'warning')
    
    return <ListGroupItem className="with-remove">
      <Button
        outline
        color="link"
        title="Remove"
        className="remove-button float-right"
        onClick={this.deleteDomain}>
          <FA icon={faTrashAlt} />
      </Button>
      
      <div className="line-clamp">
        <span title={confirmation_status}><FA icon={certificate_status === 'success' ? faLock : faCircle} className={`text-${statusColor}`} />  </span>
        <span title={domain.name}>{domain.name}</span>
      </div>
      
      <DomainSetupButton {...domain} toggleSSL={this.toggleSSL} />
      
    </ListGroupItem>
  }
}

const ProjectDomain = connect(mapStateToProps, matchDispatchToProps)(ProjectDomainComponent);

class ProjectDomains extends Component {
  
  render() {
    const { project  } = this.props;
    
    return (project && size(project.domains) > 0 ? <ListGroup className="mb-4">{map(project.domains, (domain, idx) => (
      <ProjectDomain key={idx} domain={domain} />
      ))}</ListGroup>
    : null);
  }
}

export default ProjectDomains;


// WEBPACK FOOTER //
// ./src/components/Projects/domains.js